import { createSelector } from 'reselect';
import get from 'lodash/fp/get';

import getMatch from './getMatch';

const getLocale = createSelector(
  getMatch,
  (pathMatch) => get('query.locale', pathMatch) || get('params.language', pathMatch),
);

export default getLocale;
